module.exports = __webpack_public_path__ + "img/pageright.20b66282.svg";